"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ToolbarButton = (_a) => {
    var props = tslib_1.__rest(_a, []);
    return (react_1.default.createElement(react_core_1.ToolbarItem, null,
        react_1.default.createElement(react_core_1.Button, Object.assign({}, props))));
};
exports.default = ToolbarButton;
//# sourceMappingURL=ToolbarButton.js.map